import type { IMapper } from "~/types";
import {
  type IOnboardingModel,
  type IOnboardingModelResponseModel,
  EStepsName,
} from "../../types";

export const onboardingModelMapper: IMapper<
  IOnboardingModelResponseModel,
  IOnboardingModel
> = (value) => {
  const result = { ...value };

  const insurerSection = result.sections[EStepsName.INSURER];
  if (insurerSection?.data?.customer) {
    const customer = insurerSection.data.customer;
    if (customer.naics_code === undefined) {
      customer.naics_code = null;
    }
  }

  const telematicsSection = result.sections[EStepsName.TELEMATICS];
  if (telematicsSection?.data && !Array.isArray(telematicsSection.data)) {
    telematicsSection.data = [telematicsSection.data];
  }

  return result;
};
